import {
  format,
  addDays,
  addWeeks,
  isSameDay,
  isBefore,
  isAfter,
  startOfWeek,
  startOfMonth,
  endOfWeek,
  endOfMonth,
  startOfYear,
  endOfYear,
  startOfDecade,
  endOfDecade,
  addMonths,
  eachDayOfInterval,
  eachYearOfInterval,
  isSameMonth,
  addYears,
} from "date-fns";

const weekOptions = { weekStartsOn: 1 };

export const setDateRange = {
  clear: () => [{ clear: true }, { clear: true }],
  today: () => [new Date(), new Date()],
  yesterday: () => [addDays(new Date(), -1), addDays(new Date(), -1)],
  tomorrow: () => [addDays(new Date(), 1), addDays(new Date(), 1)],
  thisWeek: () => [
    startOfWeek(new Date(), weekOptions),
    endOfWeek(new Date(), weekOptions),
  ],
  tilEndOfWeek: () => [new Date(), endOfWeek(new Date(), weekOptions)],
  lastWeek: () => [
    startOfWeek(addWeeks(new Date(), -1), weekOptions),
    endOfWeek(addWeeks(new Date(), -1), weekOptions),
  ],
  nextWeek: () => [
    startOfWeek(addWeeks(new Date(), 1), weekOptions),
    endOfWeek(addWeeks(new Date(), 1), weekOptions),
  ],
  beforeThisMonth: () => [null, endOfMonth(addMonths(new Date(), -1))],
  thisMonth: () => [startOfMonth(new Date()), endOfMonth(new Date())],
  tilEndOfMonth: () => [new Date(), endOfMonth(new Date())],
  lastMonth: () => [
    startOfMonth(addMonths(new Date(), -1)),
    endOfMonth(addMonths(new Date(), -1)),
  ],
  nextMonth: () => [
    startOfMonth(addMonths(new Date(), 1)),
    endOfMonth(addMonths(new Date(), 1)),
  ],
  thisYear: () => [startOfYear(new Date()), endOfYear(new Date())],
  tilEndOfYear: () => [new Date(), endOfYear(new Date())],
  lastYear: () => [
    startOfYear(addYears(new Date(), -1)),
    endOfYear(addYears(new Date(), -1)),
  ],
  nextYear: () => [
    startOfYear(addYears(new Date(), 1)),
    endOfYear(addYears(new Date(), 1)),
  ],
  past: () => [null, addDays(new Date(), -1)],
  future: () => [new Date(), ""],
  weekEnd: () => [new Date(), endOfWeek(new Date(), weekOptions)],
  monthEnd: () => [new Date(), endOfMonth(new Date())],
  yearEnd: () => [new Date(), endOfYear(new Date())],
};